/**
 * Common variables for server and client
 */
export const commonConfig = {
  isExported: process.env.NEXT_PUBLIC_APP_MODE === 'EXPORTED',
  assetsUrl: 'https://d1seqogdl9rul9.cloudfront.net',

  personalAccount: {
    origin: process.env.NEXT_PUBLIC_PA_URL,
  },
};
